import { pageInfoFragment } from '../graphql/fragment/page-info-fragment';
import { tagConnectionFragment } from '../graphql/fragment/tag-connection-fragment';
import { tagFragment } from '../graphql/fragment/tag-fragment';
import { tagListFragment } from '../graphql/fragment/tag-list-fragment';
import { StoreTagFragmentType } from './types';

export const storeTagFragments: StoreTagFragmentType = {
    tagListFragment,
    tagFragment,
    tagConnectionFragment,
    pageInfoFragment,
};
